import * as React from 'react';

import * as styles from '../../../Styles/svgShadow.css';

const IconRequestFullscreen = () => (
    <svg viewBox="0 0 100 100" className={styles.svgShadow}>
        <polygon points="15,56.5 25.1,66.6 34,57.7 42.3,66 33.4,74.9 43.5,85 15,85"/>
        <polygon points="56.5,85 66.6,74.9 57.7,66 66,57.7 74.9,66.6 85,56.5 85,85"/>
        <polygon points="85,43.5 74.9,33.4 66,42.3 57.7,34 66.6,25.1 56.5,15 85,15"/>
        <polygon points="43.5,15 33.4,25.1 42.3,34 34,42.3 25.1,33.4 15,43.5 15,15"/>
    </svg>
);

export default IconRequestFullscreen;